/**
 * @file adjust-product-inventory.tsx
 * @module app/modules/orders-delivery/adjust-product-inventory
 * @description Orders delivery module component for UTrade Admin.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { Button, Card, Col, Form, Row } from "react-bootstrap";
import GrayClose from "../../../../../_admin/assets/media/svg_uTrade/cross_gray.svg";
import AddPlus from "../../../../../_admin/assets/media/svg_uTrade/plus-blue.svg";
import { useEffect, useState } from "react";
import APICallService from "../../../../../api/apiCallService";
import { useNavigate, useLocation } from "react-router-dom";
import { orderReturn } from "../../../../../api/apiEndPoints";
import { orderDeliveryJSON } from "../../../../../api/apiJSON/order";
import Loader from "../../../../../Global/loader";
import Method from "../../../../../utils/methods";
import {
  CartonWithDozens,
  CartonWithPieces,
  Dozen,
  OrdersDelivery,
  Piece,
  ReceivedDirectGood,
} from "../../../../../utils/constants";
import { CustomSelect } from "../../../../custom/Select/CustomSelect";
import Validations from "../../../../../utils/validations";
import Notification from "../../../../notification/notification";
import AdjustInventory from "../../../../modals/adjust-inventory";
import { getKey } from "../../../../../Global/history";
import { warehouse as warehouseStoreString } from "../../../../../utils/storeString";
import { useWarehouse } from "../../../../context/WarehouseContext";
import ImageWithFallback from "../../../_common/components/image-with-fallback";
const AdjustProductInventory = (props: any) => {
  const { selectedWarehouse } = useWarehouse();
  const [markAsGoodsCollected, setMarkAsGoodsCollected] = useState(false);
  const navigate = useNavigate();
  const { state }: any = useLocation();
  const [fetchLoader, setFetchLoader] = useState(true);
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState<any>();
  const [variants, setVariants] = useState<any>([]);
  const [batchValidation, setBatchValidation] = useState<any>([]);
  const [returnAdjustMent, setReturnAdjustment] = useState<any>(false);
  const [adjustMentLoading, setAdjustmentLoading] = useState(false);
  const [scheduleForNextDay, setScheduleForNextDay] = useState(false);

  useEffect(() => {
    (async () => {
      await fetchDraftProducts();
    })();
  }, []);
  const fetchDraftProducts = async () => {
    setFetchLoader(true);
    let apiService = new APICallService(
      orderReturn.list,
      orderDeliveryJSON.returnList({
        route: state.routeId,
        vehicle: state.vehicle,
        warehouse: selectedWarehouse?.value || null,
      }),
      { _id: state.orderId },
      "",
      "",
      "",
      OrdersDelivery,
      selectedWarehouse?.value
    );
    let response = await apiService.callAPI();
    let temp: any = [];
    let tempValidation: any = [];
    await response.routeVehicle.variants.map((val: any) => {
      if (response.routeVehicle.isCustomerNotAvailable) {
        let batch: any = [];
        val.batches.map((batchVal: any) => {
          batch.push({ ...batchVal, maxStockCount: batchVal.stockCount });
        });
        temp.push({
          id: val.variant._id,
          title: val.variant.title,
          image: val.variant.media[0].url,
          // businessName: val.business.name,
          batch: val.batches,
          selectedBatch: batch,
          quantityType: val.quantityType,
          returnedStockCount: val.returnedStockCount
            ? val.returnedStockCount
            : val.stockCount,
        });
        tempValidation.push({ quantityGreater: false, selection: false });
      }
    });
    await setBatchValidation(tempValidation);
    await setVariants(temp);
    await setDetails(response);
    setFetchLoader(false);
  };
  const handleSelect = (event: any, index: number) => {
    let temp = [...variants];
    let tempValidation = [...batchValidation];
    tempValidation[index].selection = false;
    temp[index].selectedBatch.push({
      batch: event.batch,
      expiry: event.expiry,
      quantityType: event.quantityType,
      maxStockCount: event.stockCount,
      stockCount: 0,
    });
    setBatchValidation(tempValidation);
    setVariants(temp);
  };
  const handleChangeBatch = (event: any, index: number, batchIndex: number) => {
    let temp = [...variants];
    let tempValidation = [...batchValidation];
    tempValidation[index].selection = false;
    temp[index].selectedBatch[batchIndex] = {
      batch: event.batch,
      expiry: event.expiry,
      quantityType: event.quantityType,
      maxStockCount: event.stockCount,
      stockCount: 0,
    };
    setBatchValidation(tempValidation);
    setVariants(temp);
  };
  const handleQuantityChange = (
    value: any,
    index: number,
    batchIndex: number
  ) => {
    let temp = JSON.parse(JSON.stringify([...variants]));
    temp[index].selectedBatch[batchIndex].stockCount = value;
    setVariants(temp);
  };
  useEffect(() => {
    let temp = [...batchValidation];
    let tempVariants = JSON.parse(JSON.stringify([...variants]));
    if (tempVariants.length) {
      tempVariants.forEach((product: any, index: number) => {
        if (product.selectedBatch.length) {
          const totalSelectedBatchStock = product.selectedBatch.reduce(
            (total: any, batch: any) => total + parseInt(batch.stockCount),
            0
          );
          if (totalSelectedBatchStock === product.returnedStockCount) {
            temp[index].quantityGreater = false;
          } else {
            temp[index].valid = true;
            temp[index].quantityGreater =
              product.returnedStockCount - totalSelectedBatchStock;
            temp[index].quantityType = product.quantityType;
            temp[index].title = product.title;
            console.log(product);
          }
        }
      });
      setBatchValidation(temp);
    }
  }, [variants]);
  const handleOnKeyPress = async (event: any) => {
    // Allow only numbers
    const key = event.key;
    let validations = await Validations.allowOnlyNumbers(key);
    if (!validations) {
      event.preventDefault();
      return false;
    }
    return true;
  };
  const handleSubmit = async (scheduleForNextDay: any) => {
    let temp = [...batchValidation];
    if (variants.length) {
      variants.forEach((product: any, index: number) => {
        if (product.selectedBatch.length) {
          temp[index].selection = false;
          const totalSelectedBatchStock = product.selectedBatch.reduce(
            (total: any, batch: any) => total + parseInt(batch.stockCount),
            0
          );
          if (totalSelectedBatchStock === product.returnedStockCount) {
            temp[index].quantityGreater = false;
          } else {
            temp[index].valid = true;
            temp[index].quantityGreater =
              product.returnedStockCount - totalSelectedBatchStock;
            temp[index].quantityType = product.quantityType;
            temp[index].title = product.title;
          }
        } else {
          temp[index].selection = true;
        }
      });
    }
    const allTrue = temp.every((obj) => obj.selection === false);
    if (allTrue) {
      setLoading(true);
      let data: any = [];
      variants.map((val: any) => {
        val.selectedBatch.map((batchVal: any) => {
          data.push({
            variant: val.id,
            quantityType: batchVal.quantityType,
            stockCount: batchVal.stockCount,
            maxStockCount: batchVal.maxStockCount,
            expiry: batchVal.expiry,
            batch: batchVal.batch,
          });
        });
      });
      if (validateObjects(data)) {
        setScheduleForNextDay(scheduleForNextDay);
        let apiService = new APICallService(
          orderReturn.inventoryAdjust,
          orderDeliveryJSON.returnAdjust({
            route: state.routeId,
            vehicle: state.vehicle,
            variants: data,
            scheduleForNextDay: scheduleForNextDay,
          }),
          { _id: state.orderId },
          "",
          "",
          "",
          ReceivedDirectGood,
          selectedWarehouse?.value
        );
        let response = await apiService.callAPI();
        if (response) {
          setReturnAdjustment(true);
          // if (response) window.history.back();
        }
      }
      setLoading(false);
    }
    setBatchValidation(temp);
    setLoading(false);
  };
  function validateObjects(data: any) {
    for (const item of data) {
      if (item.stockCount > item.maxStockCount) {
        return false; // Validation failed
      }
    }
    return true; // All objects passed validation
  }
  const handleAdjustment = async () => {
    let temp = [...batchValidation];
    if (variants.length) {
      variants.forEach((product: any, index: number) => {
        if (product.selectedBatch.length) {
          temp[index].selection = false;
          const totalSelectedBatchStock = product.selectedBatch.reduce(
            (total: any, batch: any) => total + parseInt(batch.stockCount),
            0
          );
          if (totalSelectedBatchStock === product.returnedStockCount) {
            temp[index].quantityGreater = false;
          } else {
            temp[index].valid = true;
            temp[index].quantityGreater =
              product.returnedStockCount - totalSelectedBatchStock;
            temp[index].quantityType = product.quantityType;
            temp[index].title = product.title;
          }
        } else {
          temp[index].selection = true;
        }
      });
    }
    const allTrue = temp.every((obj) => obj.selection === false);
    if (allTrue) {
      setAdjustmentLoading(true);
      let data: any = [];
      variants.map((val: any) => {
        val.selectedBatch.map((batchVal: any) => {
          data.push({
            variant: val.id,
            quantityType: batchVal.quantityType,
            stockCount: batchVal.stockCount,
            maxStockCount: batchVal.maxStockCount,
            expiry: batchVal.expiry,
            batch: batchVal.batch,
          });
        });
      });
      if (validateObjects(data)) {
        setScheduleForNextDay(scheduleForNextDay);

        setReturnAdjustment(true);
        let apiService = new APICallService(
          orderReturn.markInventoryAdjust,
          orderDeliveryJSON.returnAdjust({
            route: state.routeId,
            vehicle: state.vehicle,
            variants: data,
            scheduleForNextDay: scheduleForNextDay,
          }),
          { _id: state.orderId },
          "",
          "",
          "",
          OrdersDelivery,
          selectedWarehouse?.value
        );
        let response = await apiService.callAPI();
        if (response) window.history.back();
      }
      setAdjustmentLoading(false);
    }
    setBatchValidation(temp);
    setAdjustmentLoading(false);
  };
  return (
    <>
      {batchValidation.some((obj: any) => obj.quantityGreater) ? (
        <Notification
          icon={false}
          bgColor="bg-danger"
          textColor="text-white"
          text={`The inventory adjustment quantity is not equal to the quantity that is assigned to the vehicle.`}
          iconColor="text-danger"
        />
      ) : (
        <></>
      )}
      <div className="p-5">
        <AdjustInventory
          show={returnAdjustMent}
          onHide={() => setReturnAdjustment(false)}
          onSave={handleAdjustment}
          loading={adjustMentLoading}
          moduleName={OrdersDelivery}
        />
        <Row className="align-items-center g-3 mb-7">
          <Col xs>
            <h1 className="fs-22 fw-bolder mb-0">Add Goods to Inventory</h1>
          </Col>
        </Row>
        <Card className="border border-r10px">
          <Card.Body className="px-0 py-3">
            <div className="table-responsive">
              <table className="table table-row table-rounded align-middle gs-8 gy-4 mb-0">
                <thead>
                  <tr className="fs-16 fw-600 align-middle">
                    <th className="min-w-150px text-start">Product name</th>
                    <th className="w-125px text-center">Cartons</th>
                    <th className="w-125px text-center">Dozens</th>
                    <th className="w-125px text-center">Pieces</th>
                    <th className="text-end"></th>
                  </tr>
                </thead>
                <tbody>
                  {fetchLoader ? (
                    <>
                      <tr>
                        <td colSpan={5}>
                          <div className="d-flex justify-content-center">
                            <Loader loading={fetchLoader} />
                          </div>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <>
                      {variants.length &&
                        variants.map((val: any, index: number) => {
                          return (
                            <>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="symbol symbol-50px border me-3">
                                      <ImageWithFallback
                                        src={val.image}
                                        className="object-fit-contain"
                                        alt=""
                                        noDefaultSize
                                      />
                                    </div>
                                    <div className="d-flex justify-content-start flex-column">
                                      <span className="fs-16 fw-500 text-dark">
                                        {val.title}
                                      </span>
                                      <span className="d-block fs-15 fw-500 text-gray">
                                        {val.businessName
                                          ? val.businessName
                                          : "-"}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td className="text-center">
                                  <span className="fs-16 fw-500">
                                    {`${
                                      val.quantityType === CartonWithDozens ||
                                      val.quantityType === CartonWithPieces
                                        ? val.returnedStockCount
                                        : "-"
                                    }`}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="fs-16 fw-500">
                                    {`${
                                      val.quantityType === Dozen
                                        ? val.returnedStockCount
                                        : "-"
                                    }`}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="fs-16 fw-500">
                                    {`${
                                      val.quantityType === Piece
                                        ? val.returnedStockCount
                                        : "-"
                                    }`}
                                  </span>
                                </td>
                              </tr>
                              {val.selectedBatch.length ? (
                                <>
                                  {val.selectedBatch.map(
                                    (batchVal: any, batchIndex: number) => {
                                      return (
                                        <>
                                          {" "}
                                          <tr>
                                            <td>
                                              <div className="w-300px mt-4">
                                                <CustomSelect
                                                  onChange={(event: any) => {
                                                    handleChangeBatch(
                                                      event,
                                                      index,
                                                      batchIndex
                                                    );
                                                  }}
                                                  border={
                                                    batchValidation[index]
                                                      .selection
                                                      ? "#e55451"
                                                      : ""
                                                  }
                                                  options={
                                                    val.batch.length
                                                      ? variants[index].batch
                                                          .filter(
                                                            (batch: any) => {
                                                              const isSelected =
                                                                !variants[
                                                                  index
                                                                ].selectedBatch.some(
                                                                  (
                                                                    selected: any
                                                                  ) =>
                                                                    parseInt(
                                                                      selected.batch
                                                                    ) ===
                                                                    parseInt(
                                                                      batch.batch
                                                                    )
                                                                );
                                                              return isSelected;
                                                            }
                                                          )
                                                          .map(
                                                            (catval: any) => {
                                                              return {
                                                                value:
                                                                  catval.batch,
                                                                label: `Batch ${
                                                                  catval.batch
                                                                } - ${Method.convertDateToDDMMYYYY(
                                                                  catval.expiry
                                                                )}`,
                                                                batch:
                                                                  catval.batch,
                                                                expiry:
                                                                  catval.expiry,
                                                                quantityType:
                                                                  catval.quantityType,
                                                                stockCount:
                                                                  catval.stockCount,
                                                                title: `Batch ${
                                                                  catval.batch
                                                                } - ${Method.convertDateToDDMMYYYY(
                                                                  catval.expiry
                                                                )}`,
                                                              };
                                                            }
                                                          )
                                                      : []
                                                  }
                                                  value={
                                                    val.batch.length
                                                      ? val.batch
                                                          .filter(
                                                            (item: any) =>
                                                              batchVal.batch ===
                                                              item.batch
                                                          )
                                                          .map(
                                                            (catval: any) => {
                                                              return {
                                                                value:
                                                                  catval.batch,
                                                                label: `Batch ${
                                                                  catval.batch
                                                                } - ${Method.convertDateToDDMMYYYY(
                                                                  catval.expiry
                                                                )}`,
                                                                batch:
                                                                  catval.batch,
                                                                expiry:
                                                                  catval.expiry,
                                                                quantityType:
                                                                  catval.quantityType,
                                                                stockCount:
                                                                  catval.stockCount,
                                                                title: `Batch ${
                                                                  catval.batch
                                                                } - ${Method.convertDateToDDMMYYYY(
                                                                  catval.expiry
                                                                )}`,
                                                              };
                                                            }
                                                          )
                                                      : []
                                                  }
                                                />
                                              </div>
                                            </td>
                                            <td className="text-center">
                                              <div className="stepperInput">
                                                <Button
                                                  size="sm"
                                                  className="uw-btn uw-btn-primary uw-btn-sm button button--addOnLeft"
                                                  disabled={
                                                    !(
                                                      val.quantityType ===
                                                        CartonWithDozens ||
                                                      val.quantityType ===
                                                        CartonWithPieces
                                                    )
                                                  }
                                                  onClick={(event) => {
                                                    const currentStockCount =
                                                      parseInt(
                                                        batchVal.stockCount !==
                                                          undefined
                                                          ? batchVal.stockCount
                                                          : 0
                                                      );
                                                    if (
                                                      currentStockCount >= 0 &&
                                                      currentStockCount - 1 >= 0
                                                    ) {
                                                      handleQuantityChange(
                                                        currentStockCount - 1,
                                                        index,
                                                        batchIndex
                                                      );
                                                    }
                                                  }}
                                                >
                                                  -
                                                </Button>
                                                <input
                                                  type="text"
                                                  disabled={
                                                    !(
                                                      val.quantityType ===
                                                        CartonWithDozens ||
                                                      val.quantityType ===
                                                        CartonWithPieces
                                                    )
                                                  }
                                                  value={
                                                    val.quantityType ===
                                                      CartonWithDozens ||
                                                    val.quantityType ===
                                                      CartonWithPieces
                                                      ? batchVal.stockCount
                                                      : "0"
                                                  }
                                                  min={0}
                                                  className="input stepperInput__input form-control"
                                                  onChange={(event: any) => {
                                                    const currentStockCount =
                                                      parseInt(
                                                        event.target.value
                                                      );
                                                    if (
                                                      currentStockCount >= 0
                                                    ) {
                                                      handleQuantityChange(
                                                        currentStockCount,
                                                        index,
                                                        batchIndex
                                                      );
                                                    }
                                                  }}
                                                  onKeyPress={(event: any) => {
                                                    handleOnKeyPress(event);
                                                  }}
                                                />
                                                <Button
                                                  size="sm"
                                                  className="uw-btn uw-btn-primary uw-btn-sm button button--addOnRight"
                                                  disabled={
                                                    !(
                                                      val.quantityType ===
                                                        CartonWithDozens ||
                                                      val.quantityType ===
                                                        CartonWithPieces
                                                    )
                                                  }
                                                  onClick={() => {
                                                    const currentStockCount =
                                                      parseInt(
                                                        batchVal.stockCount !==
                                                          undefined
                                                          ? batchVal.stockCount
                                                          : 0
                                                      );
                                                    if (
                                                      currentStockCount >= 0 &&
                                                      currentStockCount + 1 <=
                                                        batchVal.maxStockCount
                                                    ) {
                                                      handleQuantityChange(
                                                        currentStockCount + 1,
                                                        index,
                                                        batchIndex
                                                      );
                                                    }
                                                  }}
                                                >
                                                  +
                                                </Button>
                                              </div>
                                            </td>
                                            <td className="text-center">
                                              <div className="stepperInput">
                                                <Button
                                                  size="sm"
                                                  className="uw-btn uw-btn-primary uw-btn-sm button button--addOnLeft"
                                                  disabled={
                                                    !(
                                                      val.quantityType === Dozen
                                                    )
                                                  }
                                                  onClick={(event) => {
                                                    const currentStockCount =
                                                      parseInt(
                                                        batchVal.stockCount !==
                                                          undefined
                                                          ? batchVal.stockCount
                                                          : 0
                                                      );
                                                    if (
                                                      currentStockCount >= 0 &&
                                                      currentStockCount - 1 >= 0
                                                    ) {
                                                      handleQuantityChange(
                                                        currentStockCount - 1,
                                                        index,
                                                        batchIndex
                                                      );
                                                    }
                                                  }}
                                                >
                                                  -
                                                </Button>
                                                <input
                                                  type="text"
                                                  disabled={
                                                    !(
                                                      val.quantityType === Dozen
                                                    )
                                                  }
                                                  value={
                                                    val.quantityType === Dozen
                                                      ? batchVal.stockCount
                                                      : "0"
                                                  }
                                                  min={0}
                                                  className="input stepperInput__input form-control"
                                                  onChange={(event: any) => {
                                                    const currentStockCount =
                                                      parseInt(
                                                        event.target.value
                                                      );
                                                    if (
                                                      currentStockCount >= 0
                                                    ) {
                                                      handleQuantityChange(
                                                        currentStockCount,
                                                        index,
                                                        batchIndex
                                                      );
                                                    }
                                                  }}
                                                  onKeyPress={(event: any) => {
                                                    handleOnKeyPress(event);
                                                  }}
                                                />
                                                <Button
                                                  size="sm"
                                                  className="uw-btn uw-btn-primary uw-btn-sm button button--addOnRight"
                                                  disabled={
                                                    !(
                                                      val.quantityType === Dozen
                                                    )
                                                  }
                                                  onClick={() => {
                                                    const currentStockCount =
                                                      parseInt(
                                                        batchVal.stockCount !==
                                                          undefined
                                                          ? batchVal.stockCount
                                                          : 0
                                                      );
                                                    if (
                                                      currentStockCount >= 0 &&
                                                      currentStockCount + 1 <=
                                                        batchVal.maxStockCount
                                                    ) {
                                                      handleQuantityChange(
                                                        currentStockCount + 1,
                                                        index,
                                                        batchIndex
                                                      );
                                                    }
                                                  }}
                                                >
                                                  +
                                                </Button>
                                              </div>
                                            </td>
                                            <td className="text-center">
                                              <div className="stepperInput">
                                                <Button
                                                  size="sm"
                                                  className="uw-btn uw-btn-primary uw-btn-sm button button--addOnLeft"
                                                  disabled={
                                                    !(
                                                      val.quantityType === Piece
                                                    )
                                                  }
                                                  onClick={(event) => {
                                                    const currentStockCount =
                                                      parseInt(
                                                        batchVal.stockCount !==
                                                          undefined
                                                          ? batchVal.stockCount
                                                          : 0
                                                      );
                                                    if (
                                                      currentStockCount >= 0 &&
                                                      currentStockCount - 1 >= 0
                                                    ) {
                                                      handleQuantityChange(
                                                        currentStockCount - 1,
                                                        index,
                                                        batchIndex
                                                      );
                                                    }
                                                  }}
                                                >
                                                  -
                                                </Button>
                                                <input
                                                  type="text"
                                                  disabled={
                                                    !(
                                                      val.quantityType === Piece
                                                    )
                                                  }
                                                  value={
                                                    val.quantityType === Piece
                                                      ? batchVal.stockCount
                                                      : "0"
                                                  }
                                                  min={0}
                                                  className="input stepperInput__input form-control"
                                                  onChange={(event: any) => {
                                                    const currentStockCount =
                                                      parseInt(
                                                        event.target.value
                                                      );
                                                    if (
                                                      currentStockCount >= 0
                                                    ) {
                                                      handleQuantityChange(
                                                        currentStockCount,
                                                        index,
                                                        batchIndex
                                                      );
                                                    }
                                                  }}
                                                  onKeyPress={(event: any) => {
                                                    handleOnKeyPress(event);
                                                  }}
                                                />
                                                <Button
                                                  size="sm"
                                                  className="uw-btn uw-btn-primary uw-btn-sm button button--addOnRight"
                                                  disabled={
                                                    !(
                                                      val.quantityType === Piece
                                                    )
                                                  }
                                                  onClick={() => {
                                                    const currentStockCount =
                                                      parseInt(
                                                        batchVal.stockCount !==
                                                          undefined
                                                          ? batchVal.stockCount
                                                          : 0
                                                      );
                                                    if (
                                                      currentStockCount >= 0 &&
                                                      currentStockCount + 1 <=
                                                        batchVal.maxStockCount
                                                    ) {
                                                      handleQuantityChange(
                                                        currentStockCount + 1,
                                                        index,
                                                        batchIndex
                                                      );
                                                    }
                                                  }}
                                                >
                                                  +
                                                </Button>
                                              </div>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td colSpan={5}>
                                              {batchVal.stockCount >= 0 &&
                                              batchVal.stockCount <=
                                                batchVal.maxStockCount ? (
                                                ""
                                              ) : (
                                                <span className="fs-14 fw-500 text-danger">
                                                  Max allowed quantity in Batch-
                                                  {batchVal.batch} is{" "}
                                                  {batchVal.maxStockCount}
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        </>
                                      );
                                    }
                                  )}
                                </>
                              ) : (
                                <>
                                  <tr>
                                    <td>
                                      <div className="w-300px ">
                                        <CustomSelect
                                          // defaultValue={se.find((val: any) => {
                                          //   return val.value === generalData.brand
                                          // })}
                                          border={
                                            batchValidation[index].selection
                                              ? "#e55451"
                                              : ""
                                          }
                                          onChange={(event: any) => {
                                            handleSelect(event, index);
                                          }}
                                          options={
                                            val.batch.length
                                              ? val.batch.map((catval: any) => {
                                                  return {
                                                    value: catval.batch,
                                                    label: `Batch ${
                                                      catval.batch
                                                    } - ${Method.convertDateToDDMMYYYY(
                                                      catval.expiry
                                                    )}`,
                                                    batch: catval.batch,
                                                    expiry: catval.expiry,
                                                    quantityType:
                                                      catval.quantityType,
                                                    stockCount:
                                                      catval.stockCount,
                                                    title: `Batch ${
                                                      catval.batch
                                                    } - ${Method.convertDateToDDMMYYYY(
                                                      catval.expiry
                                                    )}`,
                                                  };
                                                })
                                              : []
                                          }
                                        />
                                      </div>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    {/* {batchVal.batch >= initialDetails.batch ? ( */}
                                    <td></td>
                                    {/* ) : (
                                <td className="text-end"></td>
                              )} */}
                                  </tr>
                                </>
                              )}
                              <tr>
                                <td colSpan={5}>
                                  <div className="separator my-5"></div>
                                </td>
                              </tr>
                            </>
                          );
                        })}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </Card.Body>
        </Card>
        {!fetchLoader ? (
          <Col className="mt-4">
            <Button
              className="uw-btn uw-btn-primary uw-btn-lg btn-lg"
              onClick={() => {
                handleSubmit(false);
              }}
            >
              {!loading && <span className="indicator-label"> Submit</span>}
              {loading && (
                <span
                  className="indicator-progress"
                  style={{ display: "block" }}
                >
                  Please wait...
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              )}
            </Button>
            <Button
              className="uw-btn uw-btn-primary uw-btn-lg btn-lg ms-10"
              onClick={() => {
                handleSubmit(true);
              }}
            >
              {!loading && (
                <span className="indicator-label">
                  {" "}
                  Schedule Delivery for the order
                </span>
              )}
              {loading && (
                <span
                  className="indicator-progress"
                  style={{ display: "block" }}
                >
                  Schedule Delivery for the order
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              )}
            </Button>
          </Col>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};
export default AdjustProductInventory;
